import React from "react";

// Options is an array of strings
const FieldRadioButton = ({ onBlur, onChange, name, options, required, value }) => {
  const defaultClass = "inline-flex justify-center items-center p-default w-full h-full cursor-pointer";
  return (
    <ul className="grid gap-3 w-full grid-cols-2">
      {options.map((option) => {
        return (
          <li className="relative" key={option.value}>
            <input
              className={`peer absolute left-0 ${defaultClass}`}
              defaultChecked={value?.toLowerCase() === option?.value.toLowerCase()}
              id={option?.value.toLowerCase()}
              name={name}
              required={required}
              type="radio"
              value={option?.value.toLowerCase()}
              onBlur={onBlur}
              onChange={onChange}
            />
            <label
              htmlFor={option?.value.toLowerCase()}
              className={`${defaultClass} relative z-10 bg-theme-secondary pointer-events-none rounded-default peer-checked:text-theme-accent peer-checked:border-theme-accent`}
            >
              <h1>{option.label}</h1>
            </label>
          </li>
        );
      })}
    </ul>
  );
};

export default FieldRadioButton;
